/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Video_Lock_TitleInputs */



/**
* | output |
* | --- |
* | "Lock Video to CC" |
*
* @param {Player_Video_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_video_lock_title = /** @type {((inputs?: Player_Video_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Video_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouiller la Video sur CC")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video auf CC sperren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blocca video su CC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрыть видео с субтитрами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloquear vídeo en CC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("锁定视频至CC")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオをCCにロックする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो को सीसी पर लॉक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bloquear vídeo para legendas")
	return /** @type {LocalizedString} */ ("Lock Video to CC")
});